import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';

@Directive({
  selector: '[boiDisableNumericInputIncrementation]'
})
export class DisableNumericInputIncrementationDirective implements AfterViewInit, OnDestroy {
  @Input('boiDisableNumericInputIncrementation') disableIncrementation: boolean;

  constructor(private readonly hostElement: ElementRef) {}

  private readonly inputSelector = '.k-numerictextbox input';
  private onWheel(event: Event): void {
    event.stopImmediatePropagation();
  }

  ngAfterViewInit(): void {
    if (this.disableIncrementation) {
      this.hostElement.nativeElement.querySelector(this.inputSelector).addEventListener('wheel', this.onWheel);
    }
  }

  ngOnDestroy(): void {
    if (this.disableIncrementation) {
      this.hostElement.nativeElement.querySelector(this.inputSelector).removeEventListener('wheel', this.onWheel);
    }
  }
}
